import { useStateValue } from "./StateProvider";
import Header from "./component/Header/Heaader";
import SideBar from "./component/SideBar/sideBar";
import Feed from "./component/Feed/feed";
import Widget from "./component/widget/widget";
import Login from "./component/login/login";
import "./App.css";

const App = () => {
  const [{ user }, dispatch] = useStateValue();
  return (
    <>
      {user ? (
        <div className="main">
          <Header />
          <div className="app__body">
            <SideBar />
            <Feed />
            <Widget />
          </div>
        </div>
      ) : (
        <Login />
      )}
    </>
  );
};

export default App;
